/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdId } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdIdResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdIdResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdId = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdId,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<GetDecisioningStudioAgentsAppGroupIdIdResult> => {
    return fetch(`/decisioning_studio_agents/${appGroupId}/${id}`, "GET", {}, { signal });
  },
  isGetDecisioningStudioAgentsAppGroupIdIdResult
);
